// Event names constants
export const EVENT_NAMES = {
  SIGNAL_COPY_TO_FORM: 'signal-copy-to-form',
  REFETCH_CURRENT_LIST: 'refetch-current-list',
  RESET_SUB_INDICATOR_COUNT: 'reset-sub-indicator-count'
} as const;
